import React, { useContext } from "react";
import {
  Anchor,
  Box,
  Grid,
  Header,
  Image,
  Nav,
  ResponsiveContext,
  // Stack,
  Text,
} from "grommet";
import logo from "../assets/AitapisskoFINAL.svg";
import { NavLink } from "react-router-dom";
import { Facebook, Instagram } from "grommet-icons";
import colors from "../colors";

// import colors from "../colors";
const menuItems = [
  { label: "Home", link: "/" },
  { label: "Team", link: "/team" },
  { label: "Community", link: "/community" },
  { label: "FAQs", link: "/faqs" },
  { label: "Resources", link: "/resources" },
  { label: "Contact", link: "/contact" },
];

const AppHeader = ({ ...props }) => {
  const viewportSize = useContext(ResponsiveContext);
  return (
    <>
      {/* Top header contains image and emergency info */}
      {/* <Stack anchor="top" fill="horizontal"> */}
      <Header background={colors.light2} pad={"small"} {...props}>
        <Grid columns={["1/3", "1/3", "1/3"]} fill="horizontal">
          <Box direction="row" gap="small" pad="small">
            <Anchor
              href="https://www.facebook.com/share/1629kZecnK/?mibextid=wwXIfr"
              color={colors.dark}
              target="_blank"
            >
              <Facebook color={colors.dark} size="30px" />
            </Anchor>
            <Anchor
              href="https://www.instagram.com/aitapissko_counseling?igsh=MTR5YzU1bzduMGox"
              color={colors.dark}
              target="_blank"
            >
              <Instagram color={colors.dark} size="30px" />
            </Anchor>
          </Box>
          <Box
            direction="column"
            justify="center"
            align="center"
            gap={"small"}
            fill="horizontal"
          >
            <Box height={viewportSize === "small" ? "120px" : "180px"}>
              <Image fill src={logo} alt="Aitapissko Logo" height={"medium"} />
            </Box>
          </Box>

          {/* <Box direction="row" fill="horizontal"> */}

          <Box
            pad={viewportSize === "small" ? "xxsmall" : "small"}
            gap={viewportSize === "small" ? "xsmall" : "medium"}
            direction={viewportSize === "small" ? "column-reverse" : "row"}
            justify="end"
          >
            <Anchor href="tel:911" size="xsmall" alignSelf={viewportSize === "small" ? "end": "start"}>
              <Text size={viewportSize === "small" ? "10px" : "small"}>
                Emergency 911/Text
              </Text>
            </Anchor>
            <Anchor href="tel:988" size="xsmall" alignSelf={viewportSize === "small" ? "end": "start"}>
              <Text size={viewportSize === "small" ? "10px" : "small"}>
                988 Suicide and Crisis Line
              </Text>
            </Anchor>
          </Box>
        </Grid>
      </Header>
      {/* </Box> */}
      {/* </Stack> */}
      {/* Second header contains nav and is "sticky" */}
      <Header
        background={colors.dark}
        pad={"small"}
        elevation="small"
        sticky="scrollup"
        {...props}
      >
        <Box
          direction="column"
          justify="center"
          align="center"
          gap={"small"}
          fill="horizontal"
        >
          {
            <Nav direction="row">
              {menuItems.map((item, i) => {
                return (
                  <Anchor
                    as={NavLink}
                    to={item.link}
                    color={"light-4"}
                    label={
                      <Text
                        size={viewportSize === "small" ? "small" : "medium"}
                      >
                        {item.label}
                      </Text>
                    }
                    key={i}
                  />
                );
              })}
            </Nav>
          }
        </Box>
      </Header>
    </>
  );
};
export default AppHeader;
